module.exports = __webpack_public_path__ + "static/media/mozilla-editor@2x.0d5d00c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/ComponentEditor/mozilla-editor@2x.png
// module id = ./src/assets/Mozilla/ComponentEditor/mozilla-editor@2x.png
// module chunks = 0